import { action, makeObservable, observable } from 'mobx';
import { RecordingMetadataBody } from 'api/types';
import { RECORDING_STATUS } from './types';

interface RecordingStoreInterface {
    data: RecordingMetadataBody | null;
    status: RECORDING_STATUS;
}

class RecordingStore implements RecordingStoreInterface {
    @observable public data: RecordingStoreInterface['data'] = null;
    @observable public status: RecordingStoreInterface['status'] = RECORDING_STATUS.INITIAL;

    public constructor() {
        makeObservable(this);
    }

    @action
    public clear() {
        this.data = null;
    }

    @action
    public setRecordingData(data: RecordingStoreInterface['data']) {
        this.data = data;
    }

    @action
    public setInitialStatus() {
        this.status = RECORDING_STATUS.INITIAL;
    }

    @action
    public setWaitingForStartStatus() {
        this.status = RECORDING_STATUS.WAITING_FOR_START;
    }

    @action
    public setRecordingStatus() {
        this.status = RECORDING_STATUS.RECORDING;
    }

    @action
    public setStoppingRecordingStatus() {
        this.status = RECORDING_STATUS.STOPPING;
    }
}

export const recordingStore = new RecordingStore();
